import { render } from "./transfer.md?vue&type=template&id=0231b4f4"
import script from "./transfer.md?vue&type=script&lang=js"
export * from "./transfer.md?vue&type=script&lang=js"
script.render = render

export default script